import { withFieldHint } from "@/src/components/HighOrderComponents";
import { NumberField } from "@/src/components/Fields/NumberField";
import { useFormContext } from "react-hook-form";

import { useFieldDebouncedCallback } from "@/src/hooks/useFieldDebouncedCallback";

const NumberFieldWithHint = withFieldHint(NumberField);

export function NumberInput(props: any) {
  const { hint, name } = props;
  const hints = hint?.hintsList;
  const form = useFormContext();
  const { control } = form;
  const debouncedUpdateField = useFieldDebouncedCallback(name);
  return (
    <NumberFieldWithHint
      {...props}
      control={control}
      name={name}
      onChange={(e, value) => {
        if (!e?.currentTarget?.closest('[role="dialog"]')) {
          debouncedUpdateField(value);
        }
      }}
      hints={hints}
    />
  );
}
